import { useMutation } from '@tanstack/react-query';
import {
  AuthOtpPinService,
  VerifyOtpDto,
  VerifyOtpEntity,
} from 'services/openapi';

export const useOtpPinVerifyOtp = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<VerifyOtpEntity, Error, VerifyOtpDto>({
      mutationFn: (variables: VerifyOtpDto) => {
        return AuthOtpPinService.otpPinControllerVerifyOtp(variables);
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
